export default async ({ store }) => {
  const validateUser = () => {
    const hasActiveKos = store.getters['profile/hasActiveKos'];

    if (!hasActiveKos) {
      window.location.href = '/?showModalKosActive=true&modalType=waiting-list';
    }
  };

  const roomCount = store.getters['profile/roomTypeActiveCount'];

  if (roomCount === undefined) {
    store.dispatch('profile/getRoomTypeActive').then(() => {
      validateUser();
    });
  } else {
    validateUser();
  }
};
